import { setBackground } from '@config'
import { useTheme } from '@mui/material'
import React, { useEffect } from 'react'

import { useThemeConfig } from './useThemeConfig'

export default function BackgroundCanvas (props: { canSetBackground: boolean }) {
  const { canSetBackground } = props
  const theme = useTheme()
  const { themeId } = useThemeConfig()

  // use animated background if theme supports it
  useEffect(() => {
    if (!canSetBackground) {
      return
    }

    const bgRefreshInterval = setBackground(themeId, theme.tokens.layerUpperBg)

    return () => {
      if (bgRefreshInterval) {
        clearInterval(bgRefreshInterval)
      }
    }
  }, [canSetBackground, theme])

  return <canvas id="background" width="2" height="2" />
}
